import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Card, Form, Tab, Grid} from 'semantic-ui-react';
import {reduxForm, FieldArray, formValueSelector} from 'redux-form';
import {Actions} from '../../../common/actions';
import {INVOICING_FORM} from '../../../common/forms';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {PANES_INDICES, panes} from '../../../common/dictionaries/binningInvoicing';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import ManualTable from './manualOrder/manualTable';
import InternalOrderContent from './internalOrder';
import InvoicingFilters from './filters';
import './invoicing.scss';

class Invoicing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeTabIndex': 0,
      'currentItem': 0,
      'clientSelected': '',
      'agencySelected': '',
      'warehouseSelected': '',
      'showData': false,
      'isPriceEditionEnabled': false,
    };
    this.setCurrentItemIndex = this.setCurrentItemIndex.bind(this);
    this.updateSelectedFilters = this.updateSelectedFilters.bind(this);
    this.updateShowDataState = this.updateShowDataState.bind(this);
    this.onTabChange = this.onTabChange.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.Invoicing,
        scopes.See
      ) &&
      !hasAccessPermission(
        this.props.permissions,
        resources.Invoicing,
        scopes.Edit
      )
    ) {
      this.props.push(paths.AccessDenied);
    }

    this.props.emptyOrdersData();
    this.props.fetchWarehouses();
  }

  updateSelectedFilters(clientSelected, agencySelected, wareHouseSelected) {
    this.setState({
      'clientSelected': clientSelected,
      'agencySelected': agencySelected,
      'warehouseSelected': wareHouseSelected,
      'showData': false,
      'invoiceSaving': false,
    });
  }

  updateShowDataState(value) {
    this.setState({'showData': value});
  }

  onTabChange(event, data) {
    const activeTab = data.activeIndex;
    const activeTabIsManualInvoice =
      activeTab === PANES_INDICES.MANUAL_INVOICING;

    this.setState({
      'activeTabIndex': activeTab,
      'clientSelected': '',
      'warehouseSelected': '',
      'showData': false,
      'invoiceSaving': false,
    });

    const dealerFilter = activeTabIsManualInvoice ? 'importers' : 'clients';
    this.props.emptyOrdersData();
    this.props.fetchDealers(dealerFilter);
    const {client, warehouse} = this.props;
    if (!activeTab && client && warehouse) {
      this.props.push('/pedidos/facturacion');
    }
  }

  renderClientData() {
    const {activeTabIndex, agencySelected} = this.state;
    const {clientInfo, agencies} = this.props;
    const isInternalsOrdersTab =
      activeTabIndex === PANES_INDICES.INTERNALS_ORDERS_INVOICING;
    if (isInternalsOrdersTab) {
      return null;
    }

    const agencyInfo =
      agencies.length && agencySelected ?
        _.find(agencies, {'code': agencySelected}) :
        {};
    return (
      <div className='description'>
        <Grid textAlign='left'>
          <Grid.Row>
            <Grid.Column width={1}>
              <h4>Dirección</h4>
            </Grid.Column>
            <Grid.Column width={4}>
              {agencyInfo.address || clientInfo.address}
            </Grid.Column>
            <Grid.Column width={1}>
              <h4>Teléfono</h4>
            </Grid.Column>
            <Grid.Column width={2}>
              {agencyInfo.phone || clientInfo.phone}
            </Grid.Column>
            <Grid.Column width={1}>
              <h4>Email</h4>
            </Grid.Column>
            <Grid.Column width={4}>{clientInfo.email || '-'}</Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }

  setCurrentItemIndex(index) {
    this.setState({'currentItem': index});
  }

  renderManualInvoicePaneContent() {
    const {clientSelected, warehouseSelected, agencySelected} = this.state;
    const {isPriceEditionEnabled, currentItem} = this.state;
    if (!clientSelected || !warehouseSelected) {
      return null;
    }
    return (
      <Card raised fluid>
        <Form className='primary-content' autoComplete='off'>
          <FieldArray
            name='items'
            component={ManualTable}
            client={clientSelected}
            warehouse={warehouseSelected}
            agency={agencySelected}
            currentItem={currentItem}
            setCurrentItemIndex={this.setCurrentItemIndex}
            isPriceEditionEnabled={isPriceEditionEnabled}
          />
        </Form>
      </Card>
    );
  }

  renderInternalOrderInvoicePaneContent() {
    if (!this.state.showData) {
      return null;
    }
    return (
      <Card raised fluid className='primary-content'>
        <InternalOrderContent />
      </Card>
    );
  }

  renderPanesContent() {
    switch (this.state.activeTabIndex) {
      default:
      case PANES_INDICES.MANUAL_INVOICING:
        return this.renderManualInvoicePaneContent();
      case PANES_INDICES.INTERNALS_ORDERS_INVOICING:
        return this.renderInternalOrderInvoicePaneContent();
    }
  }

  render() {
    const {activeTabIndex} = this.state;
    return (
      <div className='invoicing-page'>
        <Card raised fluid>
          <div className='navigation-section'>
            <Tab
              menu={{'secondary': true, 'pointing': true, 'color': 'red'}}
              panes={panes}
              activeIndex={activeTabIndex}
              onTabChange={this.onTabChange}
            />
          </div>

          <div className='title-bar'>
            <InvoicingFilters activeTabIndex={activeTabIndex}
              updateSelectedFilters={this.updateSelectedFilters}
              updateShowDataState={this.updateShowDataState} />
            {this.renderClientData()}
          </div>
        </Card>

        {this.renderPanesContent()}
      </div>
    );
  }
}

export {Invoicing};

const form = reduxForm({
  'form': INVOICING_FORM.name,
})(Invoicing);

const mapStateToProps = (state, ownProps) => {
  const {client, warehouse} = ownProps.params;
  const formValues = formValueSelector(INVOICING_FORM.name);
  const items = formValues(state, 'items');
  return {
    client,
    warehouse,
    items,
    'invoicing': state.invoicing.invoicing,
    'loadingWarehouses': state.warehouses.loading,
    'warehouses': state.warehouses.list,
    'agencies': state.dealer.agenciesList,
    'clientInfo': state.invoicing.clientInfo,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
  };
};

const {
  withRouter,
  emptyOrdersData,
  fetchDealers,
  fetchWarehouses,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  emptyOrdersData,
  fetchDealers,
  fetchWarehouses,
})(form));
